/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AgreementService } from './services/agreement.service';
import { ArcHospiService } from './services/arc-hospi.service';
import { CityService } from './services/city.service';
import { ContractService } from './services/contract.service';
import { EntityParameterService } from './services/entity-parameter.service';
import { HospitalizationService } from './services/hospitalization.service';
import { InsurerService } from './services/insurer.service';
import { KioskService } from './services/kiosk.service';
import { MaintenanceService } from './services/maintenance.service';
import { MessageService } from './services/message.service';
import { ProvinceService } from './services/province.service';
import { QuestionnaireService } from './services/questionnaire.service';
import { ReferentialService } from './services/referential.service';
import { SiteService } from './services/site.service';
import { SysParamService } from './services/sys-param.service';
import { ThrowErrorService } from './services/throw-error.service';
import { TranslationService } from './services/translation.service';
import { UserService } from './services/user.service';
import { HubKioskService } from './services/hub-kiosk.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AgreementService,
    ArcHospiService,
    CityService,
    ContractService,
    EntityParameterService,
    HospitalizationService,
    InsurerService,
    KioskService,
    MaintenanceService,
    MessageService,
    ProvinceService,
    QuestionnaireService,
    ReferentialService,
    SiteService,
    SysParamService,
    ThrowErrorService,
    TranslationService,
    UserService,
    HubKioskService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
